import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import { SidebarComponent } from './sidebar/sidebar.component';
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import { NavigatorComponent } from './navigator/navigator.component';
import { ItemComponent } from './types/item/item.component';
import { GroupComponent } from './types/group/group.component';
import { CollapsableComponent } from './types/collapsable/collapsable.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";
import {MatDialogModule} from "@angular/material/dialog";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {ContactUsComponent} from "./contact-us/contact-us.component";
import { TopBarComponent } from './top-bar/top-bar.component';
import {MatDivider} from "@angular/material/divider";
import {MatMenu, MatMenuItem, MatMenuModule} from "@angular/material/menu";
import {BreadCrumbComponent} from "../bread-crumb/bread-crumb/bread-crumb.component";
import {LinksComponent} from "../../static/links/links.component";
import {CompanyPickerComponent} from "../../components/company-picker/company-picker.component";

@NgModule({
  declarations: [
    SidebarComponent,
    NavigatorComponent,
    ItemComponent,
    GroupComponent,
    CollapsableComponent,
    TopBarComponent
  ],
  exports: [
    SidebarComponent,
    TopBarComponent
  ],
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        ContactUsComponent,
        RouterModule,
        TranslatePipe,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatDivider,
        MatMenuModule,
        BreadCrumbComponent,
        LinksComponent,
        CompanyPickerComponent
    ]
})
export class NavigationModule {}
